import React, { useEffect, useState } from 'react';
import './Faq.css';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Accordion from 'react-bootstrap/Accordion';
import faqDataEn from './faqDataEn';
import faqDataFr from './faqDataFr';

const Faq = ({ lang = 'en', defaultTabIndex = 0 }) => {
  const [faqs, setFaqs] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(defaultTabIndex);
  const [activeKey, setActiveKey] = useState("0-0");

  useEffect(() => {
    const data = lang === 'fr' ? faqDataFr : faqDataEn;
    setFaqs(Object.values(data));
    setActiveTabIndex(defaultTabIndex);
  }, [lang, defaultTabIndex]);
  const handleTabSelect = (key) => {
    const index = parseInt(key.split('-')[1], 10);
    setActiveTabIndex(index);
    setActiveKey(`${index}-0`);
  };

  return (
    <Container className="faqSection" id="faqSection">
      <h3 className="align-items-center text text-center center">FAQs</h3>
      <Tabs id="faq-tabs" className="mb-3 text-center center justify-content-center" activeKey={`tab-${activeTabIndex}`} onSelect={handleTabSelect} >
      {
        faqs.map((tab,index)=>{
          return(
            <Tab eventKey={`tab-${index}`} key={index} title={tab.title} className="row" >
              {activeTabIndex === index && (
                <Col md={10} className="mx-auto">
                  <h4>{tab.title}</h4>
                  <p>{tab.text}</p>
                  <Accordion activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
                  {
                    tab.accordian.map((item,itemIndex)=>{
                      const eventKey = `${index}-${itemIndex}`;
                      return(
                        <Accordion.Item eventKey={eventKey} key={eventKey} id={eventKey} className={activeKey === `${eventKey}` ? `${eventKey} show` : `${eventKey}`}>
                          <Accordion.Header>{item.title}</Accordion.Header>
                          {activeKey === `${eventKey}` && (
                            <Accordion.Body dangerouslySetInnerHTML={{__html:item.body}}>
                            </Accordion.Body>
                          )}
                        </Accordion.Item>
                      )
                    })
                  }
                  </Accordion>
                </Col>
              )}
            </Tab>
          )
        })
      }
      </Tabs>
    </Container>
  );
}

export default Faq;
